import ContractingState from "infrastructure/store/contracting/ContractingState";
import IAppState from "infrastructure/store/IAppState";
import { useSelector } from "react-redux";
import { ContractingFormType } from "features/contracting/enums/contractingFormType";

export const useContractingCustomerTypeValue = <T>(value: "customerType" | "commodity" | "contractCategoryCode"): T => {
  // store
  const customerType: T = useSelector<
    IAppState,
    ContractingState
  >((store) => store.contracting).progress.steps[
    ContractingFormType.CustomerType
  ].values[value];

  // return
  return customerType;
};
